/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { UpdateProcessConfigurationRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessIntakeCallRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessLanguagesRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessReqFlagsRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessRequirementsRequestDto } from '../models';
/**
 * ProcessesUpdaterRestApi - axios parameter creator
 */
export const ProcessesUpdaterRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Dismiss an intake call proposal without changing the intake call note
         * @param {string} processId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissProcessIntakeCallProposal: async (processId: string, meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('dismissProcessIntakeCallProposal', 'processId', processId)
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('dismissProcessIntakeCallProposal', 'meetingId', meetingId)
            const localVarPath = `/api/v1/processes/{processId}/intake-call/proposals/{meetingId}/dismiss`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a recruitment process requirements
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProcessDefined: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('setProcessDefined', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/defined`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a recruitment process
         * @param {string} processId 
         * @param {UpdateProcessRequestDto} updateProcessRequestDto Process details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcess: async (processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcess', 'processId', processId)
            // verify required parameter 'updateProcessRequestDto' is not null or undefined
            assertParamExists('updateProcess', 'updateProcessRequestDto', updateProcessRequestDto)
            const localVarPath = `/api/v1/processes/{processId}`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save process description and intake call note without starting analysis
         * @param {string} processId 
         * @param {UpdateProcessConfigurationRequestDto} updateProcessConfigurationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessConfiguration: async (processId: string, updateProcessConfigurationRequestDto: UpdateProcessConfigurationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessConfiguration', 'processId', processId)
            // verify required parameter 'updateProcessConfigurationRequestDto' is not null or undefined
            assertParamExists('updateProcessConfiguration', 'updateProcessConfigurationRequestDto', updateProcessConfigurationRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/configuration`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessConfigurationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or replaces the intake call note. The note is not part of the candidate analysis, so saving it leaves candidate statuses and the process status unchanged. An empty value is allowed. 
         * @summary Save the process intake call note in any process status
         * @param {string} processId 
         * @param {UpdateProcessIntakeCallRequestDto} updateProcessIntakeCallRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessIntakeCall: async (processId: string, updateProcessIntakeCallRequestDto: UpdateProcessIntakeCallRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessIntakeCall', 'processId', processId)
            // verify required parameter 'updateProcessIntakeCallRequestDto' is not null or undefined
            assertParamExists('updateProcessIntakeCall', 'updateProcessIntakeCallRequestDto', updateProcessIntakeCallRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/intake-call`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessIntakeCallRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a recruitment process languages
         * @param {string} processId 
         * @param {UpdateProcessLanguagesRequestDto} updateProcessLanguagesRequestDto Update process languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessLanguages: async (processId: string, updateProcessLanguagesRequestDto: UpdateProcessLanguagesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessLanguages', 'processId', processId)
            // verify required parameter 'updateProcessLanguagesRequestDto' is not null or undefined
            assertParamExists('updateProcessLanguages', 'updateProcessLanguagesRequestDto', updateProcessLanguagesRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/languages`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessLanguagesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a recruitment process red flags
         * @param {string} processId 
         * @param {UpdateProcessReqFlagsRequestDto} updateProcessReqFlagsRequestDto Update process red flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessReqFlags: async (processId: string, updateProcessReqFlagsRequestDto: UpdateProcessReqFlagsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessReqFlags', 'processId', processId)
            // verify required parameter 'updateProcessReqFlagsRequestDto' is not null or undefined
            assertParamExists('updateProcessReqFlags', 'updateProcessReqFlagsRequestDto', updateProcessReqFlagsRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/red-flags`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessReqFlagsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a recruitment process requirements
         * @param {string} processId 
         * @param {UpdateProcessRequirementsRequestDto} updateProcessRequirementsRequestDto Update process requirements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessRequirements: async (processId: string, updateProcessRequirementsRequestDto: UpdateProcessRequirementsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessRequirements', 'processId', processId)
            // verify required parameter 'updateProcessRequirementsRequestDto' is not null or undefined
            assertParamExists('updateProcessRequirements', 'updateProcessRequirementsRequestDto', updateProcessRequirementsRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/requirements`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessRequirementsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesUpdaterRestApi - functional programming interface
 */
export const ProcessesUpdaterRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesUpdaterRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Dismiss an intake call proposal without changing the intake call note
         * @param {string} processId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissProcessIntakeCallProposal(processId: string, meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissProcessIntakeCallProposal(processId, meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesUpdaterRestApi.dismissProcessIntakeCallProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a recruitment process requirements
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProcessDefined(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProcessDefined(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesUpdaterRestApi.setProcessDefined']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a recruitment process
         * @param {string} processId 
         * @param {UpdateProcessRequestDto} updateProcessRequestDto Process details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcess(processId, updateProcessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesUpdaterRestApi.updateProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save process description and intake call note without starting analysis
         * @param {string} processId 
         * @param {UpdateProcessConfigurationRequestDto} updateProcessConfigurationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessConfiguration(processId: string, updateProcessConfigurationRequestDto: UpdateProcessConfigurationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessConfiguration(processId, updateProcessConfigurationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesUpdaterRestApi.updateProcessConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or replaces the intake call note. The note is not part of the candidate analysis, so saving it leaves candidate statuses and the process status unchanged. An empty value is allowed. 
         * @summary Save the process intake call note in any process status
         * @param {string} processId 
         * @param {UpdateProcessIntakeCallRequestDto} updateProcessIntakeCallRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessIntakeCall(processId: string, updateProcessIntakeCallRequestDto: UpdateProcessIntakeCallRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessIntakeCall(processId, updateProcessIntakeCallRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesUpdaterRestApi.updateProcessIntakeCall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a recruitment process languages
         * @param {string} processId 
         * @param {UpdateProcessLanguagesRequestDto} updateProcessLanguagesRequestDto Update process languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessLanguages(processId: string, updateProcessLanguagesRequestDto: UpdateProcessLanguagesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessLanguages(processId, updateProcessLanguagesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesUpdaterRestApi.updateProcessLanguages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a recruitment process red flags
         * @param {string} processId 
         * @param {UpdateProcessReqFlagsRequestDto} updateProcessReqFlagsRequestDto Update process red flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessReqFlags(processId: string, updateProcessReqFlagsRequestDto: UpdateProcessReqFlagsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessReqFlags(processId, updateProcessReqFlagsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesUpdaterRestApi.updateProcessReqFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a recruitment process requirements
         * @param {string} processId 
         * @param {UpdateProcessRequirementsRequestDto} updateProcessRequirementsRequestDto Update process requirements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessRequirements(processId: string, updateProcessRequirementsRequestDto: UpdateProcessRequirementsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessRequirements(processId, updateProcessRequirementsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesUpdaterRestApi.updateProcessRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesUpdaterRestApi - factory interface
 */
export const ProcessesUpdaterRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesUpdaterRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Dismiss an intake call proposal without changing the intake call note
         * @param {string} processId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissProcessIntakeCallProposal(processId: string, meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dismissProcessIntakeCallProposal(processId, meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a recruitment process requirements
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProcessDefined(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setProcessDefined(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a recruitment process
         * @param {string} processId 
         * @param {UpdateProcessRequestDto} updateProcessRequestDto Process details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcess(processId, updateProcessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save process description and intake call note without starting analysis
         * @param {string} processId 
         * @param {UpdateProcessConfigurationRequestDto} updateProcessConfigurationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessConfiguration(processId: string, updateProcessConfigurationRequestDto: UpdateProcessConfigurationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessConfiguration(processId, updateProcessConfigurationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or replaces the intake call note. The note is not part of the candidate analysis, so saving it leaves candidate statuses and the process status unchanged. An empty value is allowed. 
         * @summary Save the process intake call note in any process status
         * @param {string} processId 
         * @param {UpdateProcessIntakeCallRequestDto} updateProcessIntakeCallRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessIntakeCall(processId: string, updateProcessIntakeCallRequestDto: UpdateProcessIntakeCallRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessIntakeCall(processId, updateProcessIntakeCallRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a recruitment process languages
         * @param {string} processId 
         * @param {UpdateProcessLanguagesRequestDto} updateProcessLanguagesRequestDto Update process languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessLanguages(processId: string, updateProcessLanguagesRequestDto: UpdateProcessLanguagesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessLanguages(processId, updateProcessLanguagesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a recruitment process red flags
         * @param {string} processId 
         * @param {UpdateProcessReqFlagsRequestDto} updateProcessReqFlagsRequestDto Update process red flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessReqFlags(processId: string, updateProcessReqFlagsRequestDto: UpdateProcessReqFlagsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessReqFlags(processId, updateProcessReqFlagsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a recruitment process requirements
         * @param {string} processId 
         * @param {UpdateProcessRequirementsRequestDto} updateProcessRequirementsRequestDto Update process requirements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessRequirements(processId: string, updateProcessRequirementsRequestDto: UpdateProcessRequirementsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessRequirements(processId, updateProcessRequirementsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessesUpdaterRestApi - interface
 */
export interface ProcessesUpdaterRestApiInterface {
    /**
     * 
     * @summary Dismiss an intake call proposal without changing the intake call note
     * @param {string} processId 
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dismissProcessIntakeCallProposal(processId: string, meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update a recruitment process requirements
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setProcessDefined(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update a recruitment process
     * @param {string} processId 
     * @param {UpdateProcessRequestDto} updateProcessRequestDto Process details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Save process description and intake call note without starting analysis
     * @param {string} processId 
     * @param {UpdateProcessConfigurationRequestDto} updateProcessConfigurationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessConfiguration(processId: string, updateProcessConfigurationRequestDto: UpdateProcessConfigurationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Creates or replaces the intake call note. The note is not part of the candidate analysis, so saving it leaves candidate statuses and the process status unchanged. An empty value is allowed. 
     * @summary Save the process intake call note in any process status
     * @param {string} processId 
     * @param {UpdateProcessIntakeCallRequestDto} updateProcessIntakeCallRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessIntakeCall(processId: string, updateProcessIntakeCallRequestDto: UpdateProcessIntakeCallRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update a recruitment process languages
     * @param {string} processId 
     * @param {UpdateProcessLanguagesRequestDto} updateProcessLanguagesRequestDto Update process languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessLanguages(processId: string, updateProcessLanguagesRequestDto: UpdateProcessLanguagesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update a recruitment process red flags
     * @param {string} processId 
     * @param {UpdateProcessReqFlagsRequestDto} updateProcessReqFlagsRequestDto Update process red flags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessReqFlags(processId: string, updateProcessReqFlagsRequestDto: UpdateProcessReqFlagsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update a recruitment process requirements
     * @param {string} processId 
     * @param {UpdateProcessRequirementsRequestDto} updateProcessRequirementsRequestDto Update process requirements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessRequirements(processId: string, updateProcessRequirementsRequestDto: UpdateProcessRequirementsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ProcessesUpdaterRestApi - object-oriented interface
 */
export class ProcessesUpdaterRestApi extends BaseAPI implements ProcessesUpdaterRestApiInterface {
    /**
     * 
     * @summary Dismiss an intake call proposal without changing the intake call note
     * @param {string} processId 
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dismissProcessIntakeCallProposal(processId: string, meetingId: number, options?: RawAxiosRequestConfig) {
        return ProcessesUpdaterRestApiFp(this.configuration).dismissProcessIntakeCallProposal(processId, meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a recruitment process requirements
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setProcessDefined(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesUpdaterRestApiFp(this.configuration).setProcessDefined(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a recruitment process
     * @param {string} processId 
     * @param {UpdateProcessRequestDto} updateProcessRequestDto Process details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesUpdaterRestApiFp(this.configuration).updateProcess(processId, updateProcessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save process description and intake call note without starting analysis
     * @param {string} processId 
     * @param {UpdateProcessConfigurationRequestDto} updateProcessConfigurationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessConfiguration(processId: string, updateProcessConfigurationRequestDto: UpdateProcessConfigurationRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesUpdaterRestApiFp(this.configuration).updateProcessConfiguration(processId, updateProcessConfigurationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or replaces the intake call note. The note is not part of the candidate analysis, so saving it leaves candidate statuses and the process status unchanged. An empty value is allowed. 
     * @summary Save the process intake call note in any process status
     * @param {string} processId 
     * @param {UpdateProcessIntakeCallRequestDto} updateProcessIntakeCallRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessIntakeCall(processId: string, updateProcessIntakeCallRequestDto: UpdateProcessIntakeCallRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesUpdaterRestApiFp(this.configuration).updateProcessIntakeCall(processId, updateProcessIntakeCallRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a recruitment process languages
     * @param {string} processId 
     * @param {UpdateProcessLanguagesRequestDto} updateProcessLanguagesRequestDto Update process languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessLanguages(processId: string, updateProcessLanguagesRequestDto: UpdateProcessLanguagesRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesUpdaterRestApiFp(this.configuration).updateProcessLanguages(processId, updateProcessLanguagesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a recruitment process red flags
     * @param {string} processId 
     * @param {UpdateProcessReqFlagsRequestDto} updateProcessReqFlagsRequestDto Update process red flags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessReqFlags(processId: string, updateProcessReqFlagsRequestDto: UpdateProcessReqFlagsRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesUpdaterRestApiFp(this.configuration).updateProcessReqFlags(processId, updateProcessReqFlagsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a recruitment process requirements
     * @param {string} processId 
     * @param {UpdateProcessRequirementsRequestDto} updateProcessRequirementsRequestDto Update process requirements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessRequirements(processId: string, updateProcessRequirementsRequestDto: UpdateProcessRequirementsRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesUpdaterRestApiFp(this.configuration).updateProcessRequirements(processId, updateProcessRequirementsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

